import React, { Component } from 'react';
// import PropTypes from 'prop-types';
import './Highlight.scss';
import imageUrl from '@images/wylkon.png';

class Highlight extends Component {
  render() {
    return (
      <section className="wy-highlight">
        <img src={imageUrl} alt="Wylkon Cardoso" />
        <div className="wy-highlight-content">
          <h1>Hello</h1>
          <div>
            <p>This is me</p>
            <ul>
              <li>Wylkon Cardoso</li>
              <li>looking to my GF smiling.</li>
              <li>doing a new Portfolio ;)</li>
              <li>trying to feel serious</li>
            </ul>
          </div>
        </div>
      </section>
    );
  }
}

export default Highlight;



// WEBPACK FOOTER //
// ./src/components/atoms/Highlight/Highlight.jsx